export interface JustPulledSkeletonProps {
  compact?: boolean;
  count?: number;
}

const CHIP_BG =
  'linear-gradient(180deg, rgba(255,255,255,0.20) 0%, rgba(153,153,153,0.20) 100%)';

/**
 * Strip of placeholder pills shown while the very first fetch is still
 * in flight. After the initial load completes, refetches don't toggle
 * loading=true — the strip stays populated with the previous items so
 * the marquee doesn't pop.
 */
export function JustPulledSkeleton({ compact = false, count = 6 }: JustPulledSkeletonProps) {
  return (
    <div className="flex gap-[6px]" aria-hidden>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={
            'shrink-0 animate-pulse rounded-[12px] ' +
            (compact ? 'h-[34px] w-[200px]' : 'h-[46px] w-[260px]')
          }
          style={{ background: CHIP_BG }}
        />
      ))}
    </div>
  );
}
